/**
 * @generated SignedSource<<05e3dae05e17b59c511295be3f908e60>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CorpTypeEnum = "CORPS" | "INDIS";
export type ErrorType = "ERR_ADSLOT" | "ERR_CARD_BIRTH" | "ERR_CARD_EXPIRED" | "ERR_CARD_NUMBER" | "ERR_CARD_PASSWORD" | "ERR_CARD_PASSWORD_FIVE_TIMES" | "ERR_CREATE_SURVEY_ANSWER" | "ERR_DUPLICATE_APPLY" | "ERR_ETC" | "ERR_EXIST_FINISH_REFUND" | "ERR_EXIST_SEARCH_HISTORY" | "ERR_EXPIRE_URL" | "ERR_HECTO_ETC" | "ERR_HOMETAX_BLOCK_ID" | "ERR_HOMETAX_CALCULATE" | "ERR_HOMETAX_COLLECT" | "ERR_HOMETAX_ETC" | "ERR_HOMETAX_EXPIRE_CERT" | "ERR_HOMETAX_IMPOSSIBLE" | "ERR_HOMETAX_INPUT" | "ERR_HOMETAX_NO_BMAN" | "ERR_HOMETAX_NO_CONTINUE_BMAN" | "ERR_HOMETAX_NO_CORPS_ID" | "ERR_HOMETAX_NO_INCOME_TAX" | "ERR_HOMETAX_NO_JUMIN_ID" | "ERR_HOMETAX_NO_REGIST_CERT" | "ERR_HOMETAX_NO_USER" | "ERR_HOMETAX_OVERLOAD" | "ERR_HOMETAX_PASSWORD" | "ERR_HOMETAX_PASSWORD_CHANGE_REQUEST" | "ERR_HOMETAX_REG_NO" | "ERR_HOMETAX_SERVER_FIX" | "ERR_HOMETAX_SESSION" | "ERR_HOMETAX_SIMPLE_AUTH" | "ERR_HOMETAX_TIMEOUT" | "ERR_LEAVE_REASON" | "ERR_LEAVE_REASON_LOG" | "ERR_NON_PRODUCT_PROMOTION" | "ERR_NOT_EXIST_HISTORY" | "ERR_NOT_EXIST_YEAR_END_TAX_SETTLEMENT" | "ERR_NO_EQUAL_TIN" | "ERR_PROMOTION" | "ERR_SSO" | "ERR_SURVEY" | "ERR_SURVEY_ANSWER" | "ERR_SURVEY_COMPLETED" | "ERR_SURVEY_EXPIRED" | "ERR_UPDATE_SURVEY_ANSWER" | "ERR_USER" | "ERR_USER_ACTION_LOG" | "ERR_USER_PHONE";
export type LoginType = "CommonCert" | "HometaxId" | "Kakao" | "Naver" | "PartnerCert";
export type simpleAuthRequestRefundTokenForLookupMutation$variables = {
  corpType: CorpTypeEnum;
  loginType: LoginType;
  tin?: string | null | undefined;
  token: string;
};
export type simpleAuthRequestRefundTokenForLookupMutation$data = {
  readonly requestRefundTokenMutation: {
    readonly email: string | null | undefined;
    readonly errors: {
      readonly code: ErrorType;
      readonly message: string | null | undefined;
    } | null | undefined;
    readonly lastLoginType: string | null | undefined;
    readonly refundToken: string | null | undefined;
    readonly result: boolean;
  };
};
export type simpleAuthRequestRefundTokenForLookupMutation = {
  response: simpleAuthRequestRefundTokenForLookupMutation$data;
  variables: simpleAuthRequestRefundTokenForLookupMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "corpType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "loginType"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tin"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "token"
},
v4 = [
  {
    "alias": "requestRefundTokenMutation",
    "args": [
      {
        "kind": "Variable",
        "name": "corpType",
        "variableName": "corpType"
      },
      {
        "kind": "Variable",
        "name": "loginType",
        "variableName": "loginType"
      },
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "token",
            "variableName": "token"
          }
        ],
        "kind": "ObjectValue",
        "name": "simpleAuth"
      },
      {
        "kind": "Variable",
        "name": "tin",
        "variableName": "tin"
      }
    ],
    "concreteType": "CheckHometaxAccountOutput",
    "kind": "LinkedField",
    "name": "checkHometaxAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Errors",
        "kind": "LinkedField",
        "name": "errors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "refundToken",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastLoginType",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "simpleAuthRequestRefundTokenForLookupMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "simpleAuthRequestRefundTokenForLookupMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "776c7cfd9b081375a104104675627871",
    "id": null,
    "metadata": {},
    "name": "simpleAuthRequestRefundTokenForLookupMutation",
    "operationKind": "mutation",
    "text": "mutation simpleAuthRequestRefundTokenForLookupMutation(\n  $corpType: CorpTypeEnum!\n  $loginType: LoginType!\n  $token: String!\n  $tin: String\n) {\n  requestRefundTokenMutation: checkHometaxAccount(corpType: $corpType, loginType: $loginType, simpleAuth: {token: $token}, tin: $tin) {\n    result\n    errors {\n      code\n      message\n    }\n    refundToken\n    email\n    lastLoginType\n  }\n}\n"
  }
};
})();

(node as any).hash = "2efe61b69a90f3d2d4ca6254aac29d99";

export default node;
